import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const contactUsColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { anonymous: {
        type: 'boolean-required',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export const contactUsEntityName = 'contactUs';
